import { Product } from '../../types';

export const fuseSeriesProducts: Product[] = [
  {
    id: "bt-fuse-swt008001",
    name: "Fuse Series Terminal - MFT (SWT008001)",
    slug: "fuse-terminal-mft-swt008001",
    category: "Brass Terminal",
    subcategory: "Fuse Series",
    description: "MFT fuse terminal designed specifically for fuse connections. High conductivity brass construction.",
    partNumber: "SWT008001",
    specifications: {
      "Tab Size Ø": "0.80 mm",
      "Cable Size SQ. MM": "2.00-3.20",
      "Description": "MFT",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-2000 Cut-1000",
    },
    images: ["/products/brass-terminals/fuse-series/SWT008001.jpg"],
    tags: ["terminal", "fuse", "brass", "mft"],
    applications: ["Automotive", "Fuse Connections"],
  },
  {
    id: "bt-fuse-swt008004",
    name: "Fuse Series Terminal - MFT (SWT008004)",
    slug: "fuse-terminal-mft-swt008004",
    category: "Brass Terminal",
    subcategory: "Fuse Series",
    description: "MFT fuse terminal designed specifically for fuse connections. High conductivity brass construction.",
    partNumber: "SWT008004",
    specifications: {
      "Tab Size Ø": "0.80 mm",
      "Cable Size SQ. MM": "2.00-3.20",
      "Description": "MFT",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-2000 Cut-1000",
    },
    images: ["/products/brass-terminals/fuse-series/SWT008004.jpg"],
    tags: ["terminal", "fuse", "brass", "mft"],
    applications: ["Automotive", "Fuse Connections"],
  },
  {
    id: "bt-fuse-swt008011",
    name: "Fuse Series Terminal - MFT New (SWT008011)",
    slug: "fuse-terminal-mft-new-swt008011",
    category: "Brass Terminal",
    subcategory: "Fuse Series",
    description: "MFT New fuse terminal designed specifically for fuse connections. High conductivity brass construction.",
    partNumber: "SWT008011",
    specifications: {
      "Tab Size Ø": "0.80 mm",
      "Cable Size SQ. MM": "2.00-3.20",
      "Description": "MFT New",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-2000 Cut-N/a",
    },
    images: ["/products/brass-terminals/fuse-series/SWT008011.jpg"],
    tags: ["terminal", "fuse", "brass", "mft"],
    applications: ["Automotive", "Fuse Connections"],
  },
  {
    id: "bt-fuse-swt008021",
    name: "Fuse Series Terminal - FT (SWT008021)",
    slug: "fuse-terminal-ft-swt008021",
    category: "Brass Terminal",
    subcategory: "Fuse Series",
    description: "FT fuse terminal designed specifically for fuse connections. High conductivity brass construction.",
    partNumber: "SWT008021",
    specifications: {
      "Tab Size Ø": "0.80 mm",
      "Cable Size SQ. MM": "2.50-3.50",
      "Description": "FT",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-1500 Cut-1000",
    },
    images: ["/products/brass-terminals/fuse-series/SWT008021.jpg"],
    tags: ["terminal", "fuse", "brass", "ft"],
    applications: ["Automotive", "Fuse Connections"],
  },
  {
    id: "bt-fuse-swt008031",
    name: "Fuse Series Terminal - MFT Window (SWT008031)",
    slug: "fuse-terminal-mft-window-swt008031",
    category: "Brass Terminal",
    subcategory: "Fuse Series",
    description: "MFT Window fuse terminal designed specifically for fuse connections. High conductivity brass construction.",
    partNumber: "SWT008031",
    specifications: {
      "Tab Size Ø": "0.80 mm",
      "Cable Size SQ. MM": "1.80-2.80",
      "Description": "MFT Window",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-2000 Cut-1000",
    },
    images: ["/products/brass-terminals/fuse-series/SWT008031.jpg"],
    tags: ["terminal", "fuse", "brass", "mft", "window"],
    applications: ["Automotive", "Fuse Connections"],
  },
];
